const styles = (theme) => ({
  root: {
    flexGrow: 1,
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },

  typography: {
    padding: theme.spacing(2),
  },
  shape: {
    backgroundColor: theme.palette.primary.main,
    width: 40,
    height: 40,
  },
  themeSwitchLabel: {
    height: 24,
  },
  alignCenter: {
    verticalAlign: 'middle',
  },
  shapeCircle: {
    borderRadius: theme.shape.borderRadius,
  },
  textCenter: {
    textAlign: 'center',
  },
  badge: {
    cursor: 'pointer',
  },
});

export default styles;

/*
 main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  */
